module.exports = __webpack_public_path__ + "static/media/event-2.9cd66fb0.png";